import React from "react";

export default function Share(props: React.ComponentProps<"svg">) {
    return (
        <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg"
            width="27"
            height="30"
            viewBox="0 0 27 30"
        >
            <g fill="none" fillRule="evenodd">
                <g stroke="currentColor" strokeWidth="1.6">
                    <g>
                        <g>
                            <path
                                d="M7.2 4.8L12.4 0 17.6 4.8M12.4.8L12.4 19.2M0 12.8v8.8c0 2.651 2.149 4.8 4.8 4.8H20c2.651 0 4.8-2.149 4.8-4.8v-8.8h0"
                                transform="translate(-313 -1135) translate(232 1122) translate(82 15)"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
